/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deleteeventliveroomone4Inputs */

const en_deleteeventliveroomone4 = /** @type {(inputs: Deleteeventliveroomone4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 person is in the Live Room right now. Deleting ends the Live Room for them.`)
};

const de_deleteeventliveroomone4 = /** @type {(inputs: Deleteeventliveroomone4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerade ist 1 Person im Live Room. Löschen beendet den Live Room für sie.`)
};

/**
* | output |
* | --- |
* | "1 person is in the Live Room right now. Deleting ends the Live Room for them." |
*
* @param {Deleteeventliveroomone4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const deleteeventliveroomone4 = /** @type {((inputs?: Deleteeventliveroomone4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deleteeventliveroomone4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deleteeventliveroomone4(inputs)
	return de_deleteeventliveroomone4(inputs)
});
export { deleteeventliveroomone4 as "deleteEventLiveRoomOne" }